import { RailcarTrackPositionResponseDto, RailTracksApi } from '@planning/app/api'
import { createApiClient } from '@planning/app/http-client'
import { Event, IEvent, IQueryHandler, IQueryMessage } from '@tom-ui/utils'

export class GetRailcarTrackPositionsQuery implements IQueryMessage {
  static type = 'GetRailcarTrackPositionsQuery'
  type = GetRailcarTrackPositionsQuery.type

  constructor(public ids: number[]) {}

  getKey = () => {
    return JSON.stringify(this)
  }
}

const httpClient = createApiClient(RailTracksApi)

export const getRailcarTrackPositionsQueryHandler: IQueryHandler<
  GetRailcarTrackPositionsQuery,
  IEvent<RailcarTrackPositionResponseDto[]>
> = async query => {
  const { data } = await httpClient.railcarTrackPositions(query.ids)

  return new Event(GetRailcarTrackPositionsQuery.type, data)
}
